import { render, staticRenderFns } from "./SectionPrice.vue?vue&type=template&id=f4baec14&"
import script from "./SectionPrice.vue?vue&type=script&lang=js&"
export * from "./SectionPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports